import { Stocktake } from "../../models/RestModels";

export function getEmptyStocktake(): Stocktake
{
		return {
			id: 0,
			created: new Date(),
			created_by_user_id: 0,
			status: 'ACTIVE',
			stock_adjustment: 'DIFFERENCE',
			store_id: 0,
			updated: new Date(),
			updated_by_user_id: null,
		}
}
